export function toMoney(num: number, options?: Intl.NumberFormatOptions) {
  try {
    return new Intl.NumberFormat("ru-RU", options).format(num);
  } catch (e) {
    return;
  }
}
